import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Zum hellen Modus wechseln' : 'Zum dunklen Modus wechseln'}
      title={theme === 'dark' ? 'Light Mode aktivieren' : 'Dark Mode aktivieren'}
      className="relative w-10 h-10 rounded-xl bg-slate-100/90 dark:bg-slate-800/80 border border-slate-200/80 dark:border-white/10 shadow-sm hover:border-emerald-500/40 dark:hover:border-emerald-400/40 hover:shadow-md hover:shadow-emerald-500/10 transition-all duration-300 flex items-center justify-center group overflow-hidden"
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
    >
      {/* Sun Icon */}
      <motion.div
        initial={false}
        animate={{
          rotate: theme === 'dark' ? 90 : 0,
          scale: theme === 'dark' ? 0 : 1,
          opacity: theme === 'dark' ? 0 : 1,
        }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        className="absolute flex items-center justify-center"
      >
        <i className="ri-sun-line text-lg text-amber-500 group-hover:text-amber-600 transition-colors"></i>
      </motion.div>

      {/* Moon Icon */}
      <motion.div
        initial={false}
        animate={{
          rotate: theme === 'dark' ? 0 : -90,
          scale: theme === 'dark' ? 1 : 0,
          opacity: theme === 'dark' ? 1 : 0,
        }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        className="absolute flex items-center justify-center"
      >
        <i className="ri-moon-clear-line text-lg text-emerald-400 group-hover:text-emerald-300 transition-colors"></i>
      </motion.div>

      {/* Subtle Radial Hover Glow */}
      <div className="absolute inset-0 bg-gradient-to-tr from-emerald-500/10 via-transparent to-cyan-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
    </motion.button>
  );
};

export default ThemeToggle;
